import React from 'react'
import PropTypes from 'prop-types'
import FeatureWrapper from '../FeatureWrapper'
import FeatureTitle from '../FeatureTitle'
import FeatureItems from '../FeatureItems'
import { withRouter } from 'react-router'

import { Select, Option } from 'react-a11y-select'
import 'react-a11y-select/src/styles.css'

const getTypeColor = SkuByType => {
  const colors = []

  SkuByType.map(item => {
    if (item.COR) {
      const verify = colors.filter(x => x.COR === item.COR).length > 0

      if (!verify) {
        const current =
          SkuByType.filter(x => x.currentSku === true && x.COR === item.COR)
            .length > 0

        colors.push({ sku: item.sku, COR: item.COR, currentSku: current })
      }
    }
  })

  return colors
}

const getSKUSelected = SkuByType => {
  return SkuByType.filter(x => x.currentSku === true)[0].sku
}

const ColorFeature = ({ history: { push }, SkuByType }) => {
  const selectedSKU = getSKUSelected(SkuByType)

  return (
    <FeatureWrapper>
      <FeatureTitle ariaLabelledby='color-option'>
        Selecione a cor:
      </FeatureTitle>
      <FeatureItems className='px-1'>
        <Select labelledBy='color-option' label='Selecione a cor' placeholderText={`Seleciona a cor`} initialValue={selectedSKU} onChange={e => push(`/products/${e}`)}>
          {
            getTypeColor(SkuByType).map(item => {
              return <Option value={item.sku} label={item.COR}>
                {item.COR}
              </Option>
            })
          }
        </Select>
      </FeatureItems>
    </FeatureWrapper>
  )
}

ColorFeature.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  SkuByType: PropTypes.array
}

export default withRouter(ColorFeature)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/ColorFeature.js